import React, { useContext, useMemo } from "react";
import "./DashboardLeftBottom.css";
import { AppContext } from "../../appContext";
import { getAvatarById, getAvatarByKey, getAvatarList } from "../../utils/avatars";

const avatars = getAvatarList();

const getAvatarByNameHash = (name:string) =>{
    const hash = name
        .split('')
        .reduce((ac, it)=>((it.charCodeAt(0) + ac) % avatars.length), 0);
    const key = avatars[hash]
    return getAvatarByKey(key)
}

interface IDashboardLeftBottomProps{
    selectedButton?: string;
    onSelect?: (name: string)=>void;
}

export const DashboardLeftBottom = ({selectedButton = 'learning', onSelect}: IDashboardLeftBottomProps)=>{
    const {userSettings, user} = useContext(AppContext);
    const avatarUrl = useMemo(()=>{
        return userSettings?.customAvatarUrl || (user ? getAvatarByNameHash(user?.email) : null);
    }, [userSettings, user]);
    const buttonTypes = ['plus', 'upcoming', 'learning'];
    
    return (
        <div className="dashboardLeftBottom">
            {buttonTypes.map(buttonType=>{
                return <div 
                    key={`bottom-button-${buttonType}`}
                    className={`button dashboardLeftBottom_button dashboardLeftBottom_button--${buttonType} ${selectedButton == buttonType ? 'dashboardLeftBottom_button--active' : ''}`}
                    onClick={()=>{
                        onSelect?.(buttonType);
                    }}
                >
                
                </div>
            })}
            <div className="dashboardLeftBottom_button_border_wrap">
                {selectedButton == 'avatar' && <div className="dashboardLeftBottom_button_border"></div>}
                <div className={`button dashboardLeftBottom_button dashboardLeftBottom_button--avatar`} style={{backgroundImage: `url(${avatarUrl})`, filter:'none'}}
                    onClick={()=>{
                        onSelect?.('avatar');
                    }}
                >
            </div>
                
            </div>
        </div>
    )
}